import axios, { AxiosRequestConfig, AxiosRequestTransformer } from "axios";
import AppEnv from "src/app/AppEnv";

const apiClient = axios.create({
  baseURL: `${AppEnv.urlBack}/api`,
  timeout: !isNaN(parseInt(AppEnv.timeout)) ? parseInt(AppEnv.timeout) : 60000,
  responseType: "blob",
  validateStatus: status => status === 200,
});

const requestTranformer = <Data>(data: Data) => {
    return data;
};

export const callAppAPIByte = async <Data extends object | void = void>(config: AxiosRequestConfig) => {
  const requestConfig = {
    ...config,
    transformRequest: [
      (data: Data) => requestTranformer<Data>(data),
      ...(axios.defaults.transformRequest as AxiosRequestTransformer[]),
    ],
  };
  return await apiClient.request(requestConfig);
};
